export default {
  name: 'Map - 1',
  tab: 'map',
  type: 'map-default-section',
  content: {
    title: 'Map section',
    introtext:
      '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p><p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>',
    buttons: '',
    'map-latitude': '59.9139',
    'map-longitude': '10.7522',
    'map-zoom': '10'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '',
    'parallax-background-image': '0',
    'custom-padding': '0',
    'padding-top': '60px',
    'padding-bottom': '60px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h4',
    'introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'start',
    'content-vertical-alignment': 'center',
    'image-size': 'md',
    'image-position': 'right',
    'content-box': '0',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-rounded': '0'
  },
  advanced: {}
}
